import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import EmailValidator from "../validation/validators/EmailValidator";
import PhoneNumberValidator from "../validation/validators/PhoneNumberValidator";
import RequiredValueValidator from "../validation/validators/RequiredValueValidator";

export interface TPasswordResetCredentials {
  username: string;
  email: string;
  phone: string;
}

export interface IPasswordResetCredentials extends TPasswordResetCredentials {}

const PasswordResetCredentials = Model(
  (model: TPasswordResetCredentials): IPasswordResetCredentials => {
    const _credentials: TPasswordResetCredentials = Object.assign({}, model);

    const create = (
      credentials: IPasswordResetCredentials
    ): IPasswordResetCredentials => {
      let obj = ValidatableObject(credentials);

      obj.addValidator(RequiredValueValidator("username"));
      obj.addValidator(RequiredValueValidator("email"));
      obj.addValidator(RequiredValueValidator("phone"));
      obj.addValidator(EmailValidator("email"));
      obj.addValidator(PhoneNumberValidator("phone"));
      return obj;
    };

    const credentials = {
      get username() {
        return _credentials.username;
      },
      set username(value) {
        _credentials.username = value;
      },
      get email() {
        return _credentials.email;
      },
      set email(value) {
        _credentials.email = value;
      },
      get phone() {
        return _credentials.phone;
      },
      set phone(value) {
        _credentials.phone = value;
      }
    };

    return create(credentials);
  }
);

export default PasswordResetCredentials;
